<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">
          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="选择老人" required prop="userName">
                <el-input v-model="addForm.userName" placeholder="请选择评估老人" disabled>
                  <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="评估类型" required prop="checkinAssessClassCode">
                <el-select v-model="addForm.checkinAssessClassCode" placeholder="请选择评估类型" style="width: 100%">
                  <el-option
                      v-for="item in listClass"
                      :key="item.checkinAssessClassCode"
                      :label="item.name"
                      :value="item.checkinAssessClassCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>



      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm('addForm')">下一步</el-button>
      </div>
    </div>


    <GetElderly ref="myGetElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false"  v-on:setElderly="setElderly"></GetElderly>

    <SelectItem ref="mySelectItem" v-show="showModalSelectItem" v-on:closeSelectItem="closeSelectItem"
                v-on:getListOut="getListOut" v-on:closeOut="closeOut"></SelectItem>


  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import GetElderly from "@/views/Elderly/Comm/ElderlyInsCheckIn";

import SelectItem from "./SelectItem";


export default {
  name: 'Add',
  props: [],
  data() {
    return {

      loading: false,
      showModalGetElderly: false,

      showModalSelectItem: false,

      addForm:{
        timeStr:timeStr,
        sign:'',
        userName:'',
        userCode:'',
        elderlyCode:'',
        checkinAssessClassCode:'',
      },

      listClass:[],

      rules:{
        userName:[
          { required: true, message: '请选择老人', trigger: 'blur' }
        ],
        checkinAssessClassCode:[
          { required: true, message: '请选择评估类型', trigger: 'blur' },
        ],
      }


    }
  },
  components: {GetElderly,SelectItem},
  methods: {
    init(){
      this.$refs.addForm.resetFields();
      this.getList();
    },
    closeSelf() {
      this.$emit("closeSelectElderly");
    },


    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myGetElderly.init();
    },
    setElderly(row){
      this.addForm.userCode=row.userCode;
      this.addForm.phone = row.phone;
      this.addForm.userName = row.name;
      this.addForm.idCard = row.idCard;
      this.addForm.governmentCode = row.governmentCode;
      this.addForm.elderlyCode = row.elderlyCode;
    },

    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CheckinAssessGroup/GetListByClass",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.listClass=response.data.data
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },

    confirm(addForm){

      this.$refs[addForm].validate((valid) => {
        if(valid){

          this.showSelectItem();

        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    showSelectItem(){
      this.showModalSelectItem = !this.showModalSelectItem;
      this.$refs.mySelectItem.init(this.addForm.elderlyCode,this.addForm.userName,this.addForm.checkinAssessClassCode);
    },
    closeSelectItem(){
      this.showModalSelectItem = !this.showModalSelectItem;
    },

    getListOut(){
      this.$emit("getList");
    },
    closeOut(){
      this.closeSelf();
    },


  }
}
</script>

